<template>
  <div class="paper-container" style="display: flex">
    <div class="content">
      <Item
        v-for="(v, i) in itemList"
        :key="i"
        :curcer="v.articleId"
        :banTo='true'
        :every="v"
        @itemClick="goDetail(v)"
        style="background: none; box-shadow: none"
      ></Item>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
    </div>
  </div>
</template>

<script>
import Item from "@/components/pager/Item";
import mixin from "@/mixins/scrollPager";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    Item,
    Scroll
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        id: this.$route.query.id,
        pageNo: 1,
        pageSize: 10,
        userType: 2,
      },
    };
  },
  created() {
    this.getList(this.params);
  },
  methods: {
    async getList(data) {
      const resp = await this.$apis.hundredServe.getSyncMonographList(data);
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = this.pageNum >= this.total / 10;
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/concentrationDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";
</style>
